import React from 'react';
import { Container, Typography } from '@mui/material';
import NoAssetFound from '../../assets/images/no-asset.svg';

const NoAsset = () => {
  return (
    <Container
      maxWidth="xl"
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '80vh',
        width: '500px',
        textAlign: 'center',
      }}
    >
      <div>
        <img src={NoAssetFound} alt="No Asset" />
      </div>
      <Typography variant="h4">No assets found</Typography>
      <Typography color="grey" marginTop={2}>
        There is no list of active assets on the platform. Please contact us if
        you need further information.
      </Typography>
    </Container>
  );
};

export default NoAsset;
